import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosConfig"; // Use axios instance
import { toast } from "react-toastify";

// Async thunk to fetch combined wallet and transaction data
export const fetchWalletData = createAsyncThunk(
  "wallet/fetchWalletData",
  async ({ page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    try {
      // Fetch both wallet info and transactions in parallel or sequentially
      const walletPromise = axiosInstance.get("/wallet"); // Corrected endpoint
      const transactionsPromise = axiosInstance.get("/wallet/transactions", {
        params: { page, limit },
      }); // Corrected endpoint

      const [walletResponse, transactionResponse] = await Promise.all([
        walletPromise,
        transactionsPromise,
      ]);

      return {
        wallet: walletResponse.data,
        transactions: transactionResponse.data,
      };
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to load wallet data";
      toast.error(message);
      return rejectWithValue({ message });
    }
  }
);

// Removed deposit and withdraw thunks

const initialState = {
  wallet: null, // Stores wallet info { balance, currency, updatedAt }
  transactions: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalTransactions: 0,
    limit: 10,
  },
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    resetWalletState: (state) => {
      // Reset to initial state, useful on component unmount
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch wallet data (combined action)
      .addCase(fetchWalletData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchWalletData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.wallet = action.payload.wallet; // Store wallet object
        state.transactions = action.payload.transactions.transactions; // Access nested array
        state.pagination = {
          currentPage: action.payload.transactions.currentPage,
          totalPages: action.payload.transactions.totalPages,
          totalTransactions: action.payload.transactions.totalTransactions,
          limit: action.payload.transactions.limit || 10, // Ensure limit is set
        };
      })
      .addCase(fetchWalletData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
    // Removed reducers for deposit and withdraw
  },
});

export const { resetWalletState } = walletSlice.actions;

export default walletSlice.reducer;
